var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("You have left this browser idle for 10 minutes.")]),_c('p',[_vm._v(_vm._s(_vm.time)+" seconds left")])])
}
var staticRenderFns = []

export { render, staticRenderFns }